import React, { useCallback } from 'react'

import Sidebar from 'components/App/DesktopView/Layout/Sidebar'

import SearchRawCount from '../SearchRawCount'
import Item from '../Item'
import Group from '../Group'
import AvailabilityStatus from '../AvailabilityStatus'

export default function FolderCollection({
  collectionId,
  name,
  color,
  queryId,
  linkTo,
  open,
  onClick,
  itemAndGroupIds,
  hideName,
}) {
  const handleClick = useCallback(
    evt => {
      if (onClick) onClick(collectionId, evt)
    },
    [onClick, collectionId]
  )

  const header = (
    <Sidebar.Header
      as="span"
      to={linkTo}
      onClick={handleClick}
      active={open}
      count={<SearchRawCount queryId={queryId} />}
      dotColor={color}
    >
      <div>{name}</div>
      <AvailabilityStatus widgetId={collectionId.replace(/wid_/, '')} />
    </Sidebar.Header>
  )

  return (
    <Sidebar.ToplevelAccordion
      title={!hideName && header}
      active={open}
      key={collectionId}
      allowMultiple
    >
      {itemAndGroupIds.map(({ id: listId, type }) => {
        if (type === 'item') {
          return <Item key={listId} itemId={listId} padded={3} />
        }
        if (type === 'group') return <Group key={listId} groupId={listId} />
        return null
      })}
    </Sidebar.ToplevelAccordion>
  )
}
